// Agent-authored full IT candidate. Story IDs 80–84, spam 180–182.
/* eslint-disable */
export function getEmails(){return [
  {
    "id": 80,
    "from": {
      "email": "p.witzgold@pronto-posto.com",
      "name": "Petra W",
      "avatar": require("@src/assets/images/portrait/petra.png").default
    },
    "to": [
      {
        "name": "Rafaela S",
        "email": "rafaela.s@pronto-posto.com"
      }
    ],
    "subject": "St. Helen — una nuova storia?",
    "cc": [],
    "bcc": [],
    "message": "Ehi Rafaela,<p>Ho sentito al lavoro che il tuo fidanzato ha vinto dei biglietti per la <b>St. Helen</b>.<br><br>Ti ricordi quell’articolo su Casale a cui stavo lavorando qualche tempo fa?<br>Dagli un’altra occhiata… Non ci crederai, ma nelle mie ricerche era saltato fuori anche il nome di <b>Giuliano Hoffmann</b>.<br><br>E sai chi è? <b>IL capitano della St. Helen.</b><br><br>Fai un salto sul sito della <b>Atlantic Academy</b>. È l’istituto presso cui il capitano sostiene di essersi diplomato…<br><br>Non ti dirò certo di lavorare durante le vacanze, ma QUESTA sarebbe una storia fantastica.<br><br>Sono felice di aiutarti come posso, ma fai attenzione a dove e come annoti le tue ricerche. Persone del genere sono sempre all’erta e hanno ottimi contatti.<br><br>Stammi bene, ci vediamo domani,<br>Petra",
    "attachments": [],
    "isStarred": true,
    "labels": [
      "work"
    ],
    "time": "Tue. Jan. 31 2023 15:43:00 GMT+0000 (GMT)",
    "replies": [],
    "folder": "inbox",
    "isRead": true
  },
  {
    "id": 81,
    "from": {
      "email": "p.witzgold@pronto-posto.com",
      "name": "Petra W",
      "avatar": require("@src/assets/images/portrait/petra.png").default
    },
    "to": [
      {
        "name": "Rafaela S",
        "email": "rafaela.s@pronto-posto.com"
      }
    ],
    "subject": "Re: Un vecchio fantasma della nave?",
    "cc": [],
    "bcc": [],
    "message": "Ehi Rafaela,<p>Sinceramente, questa storia del <b>vecchio fantasma della nave</b> sembra più adatta alle pagine di pettegolezzi. Non possiamo pubblicare storie di fantasmi!<br><br>Non hai niente sul capitano o sull’equipaggio?",
    "attachments": [],
    "isStarred": false,
    "labels": [
      "work"
    ],
    "time": "Mon. Mar. 06 2023 10:35:00 GMT+0000 (GMT)",
    "replies": [
      {
        "id": 82,
        "from": {
          "email": "rafaela.s@pronto-posto.com",
          "name": "Rafaela S",
          "avatar": require("@src/assets/images/portrait/rafaela.png").default
        },
        "to": [
          {
            "name": "Petra W",
            "email": "p.witzgold@pronto-posto.com"
          }
        ],
        "subject": "Un vecchio fantasma della nave?",
        "cc": [],
        "bcc": [],
        "message": "Ciao Petra,<p>Certo che ho portato il mio taccuino. Ci tengo le informazioni più importanti: sì, lo so, sono proprio all’antica. È praticamente sempre con me, quindi non preoccuparti. Non sarà facile per nessuno metterci le mani ;) <br><br>Ma avevi ragione, c’è qualcosa di strano su questa nave. Ho preso qualche appunto:<br><br><b>Un vecchio fantasma della nave?</b><br>- Petra dice che non dovrei scriverne, ma secondo me c’è dell’altro.<br>- Tobia dice: il fantasma vive nella cabina accanto alla sua. Una donna dai capelli scuri sta sempre nel corridoio a fissare quella cabina, ma sparisce non appena arriva qualcuno. → Quando le ho parlato, mi ha evitata. Chi è? Forse sa qualcosa.<br>- Tobia sta solo sognando? Non so se crederci.<br><br><i>Grazie di preoccuparti per me, Petra :)</i>",
        "attachments": [],
        "isStarred": false,
        "labels": [
          "work"
        ],
        "time": "Sun. Mar. 05 2023 20:24:00 GMT+0000 (GMT)",
        "replies": [],
        "folder": "sent",
        "isRead": true
      }
    ],
    "folder": "inbox",
    "isRead": true
  },
  {
    "id": 83,
    "from": {
      "email": "p.witzgold@pronto-posto.com",
      "name": "Petra W",
      "avatar": require("@src/assets/images/portrait/petra.png").default
    },
    "to": [
      {
        "name": "Rafaela S",
        "email": "rafaela.s@pronto-posto.com"
      }
    ],
    "subject": "Re: Altri appunti",
    "cc": [],
    "bcc": [],
    "message": "Rafaela, fai attenzione, ti prego! Se diventa troppo pericoloso, lascia perdere!",
    "attachments": [],
    "isStarred": false,
    "labels": [
      "work"
    ],
    "time": "Thu. Mar. 09 2023 08:12:00 GMT+0000 (GMT)",
    "replies": [
      {
        "id": 84,
        "from": {
          "email": "rafaela.s@pronto-posto.com",
          "name": "Rafaela S",
          "avatar": require("@src/assets/images/portrait/rafaela.png").default
        },
        "to": [
          {
            "name": "Petra W",
            "email": "p.witzgold@pronto-posto.com"
          }
        ],
        "subject": "Altri appunti",
        "cc": [],
        "bcc": [],
        "message": "Ciao Petra,<p>Sì… probabilmente hai ragione. Anche l’equipaggio si comporta in modo strano. Non ho ancora niente di concreto, ma alcune cose hanno attirato la mia attenzione:<br><br><b>Il capitano</b><br>- Intervista dell’08/03: molto scortese, evita le mie domande.<br>- www.atlantic-academy.com<br>- L’equipaggio non dice una sola parola contro di lui, e lui li copre: sono tutti d’accordo (?!)<br>- Durante l’intervista sono riuscita a prendere la sua tessera. La 01 dovrebbe dare accesso a tutte le cabine. Mi serve solo per un momento, poi la farò ricomparire. Non si accorgerà di niente.<br><br><b>Altro</b><br>- Ogni volta che esco dalla cabina ho la sensazione che ci sia qualcuno… mi stanno seguendo?<br>- Romy e Alessio sembrano una coppia<br>- Tobia dice che nessuno vuole aiutarlo per i rumori nella cabina accanto alla sua<br>- Alessio e Romy vogliono soldi per un’intervista → si lasciano corrompere??<br>- Volevo capire che cosa stesse succedendo con quella donna e ho scoperto qualcosa di brutto. Devo sparire dalla circolazione per un po’: sta diventando troppo pericoloso…<br><br>Ci sono anche altre cose, ma preferisco annotarle soltanto su carta.",
        "attachments": [],
        "isStarred": false,
        "labels": [
          "work"
        ],
        "time": "Wed. Mar. 08 2023 21:03:00 GMT+0000 (GMT)",
        "replies": [],
        "folder": "sent",
        "isRead": true
      }
    ],
    "folder": "inbox",
    "isRead": true
  }
]}
export function getSpam(){return [
  {
    "id": 180,
    "from": {
      "email": "offers@instant-crypto.pro",
      "name": "Instant Crypto Offers",
      "avatar": require("@src/assets/images/portrait/crypto.png").default
    },
    "to": [
      {
        "name": "Rafaela S",
        "email": "rafaela.s@pronto-posto.com"
      }
    ],
    "subject": "ESCLUSIVO: Guadagna il 5000% in 3 giorni!",
    "cc": [],
    "bcc": [],
    "message": "<p>Ehi,</p><p>Sei stato selezionato per il nostro programma di investimento segreto. Ottieni rendimenti elevati in tempi record: bastano 100 € per iniziare. Contatta il nostro team per iscriverti.</p><br><p>Un saluto,<br>Instant Crypto Offers</p>",
    "attachments": [],
    "isStarred": false,
    "labels": [
      "personal"
    ],
    "time": "Sat. Feb. 04 2023 12:12:00 GMT+0000 (GMT)",
    "replies": [],
    "folder": "inbox",
    "isRead": false
  },
  {
    "id": 181,
    "from": {
      "email": "funnybiz@wonderworld.com",
      "name": "Wonderworld FunBiz",
      "avatar": require("@src/assets/images/portrait/funbiz.png").default
    },
    "to": [
      {
        "name": "Rafaela S",
        "email": "rafaela.s@pronto-posto.com"
      }
    ],
    "subject": "Incredibbile ma Vero!!! 😜",
    "cc": [],
    "bcc": [],
    "message": "<p>Ehi Rafaela,</p><p>Non ci crederrai, ma proprio adesso è partita la nostra super-mega-offertona! 😎<br>Chi partecipa subito riceve adesivi unicorno gratis + un pacchetto di imbattibili caramelle delle meraviglie.</p><p>Quindi non aspettare tropo, o spariranno in un lampo! 🦄🍬<br>E psst… non dire a nessuno il mio consiglio segreto, se no è tutto finito!</p><br><p>Tante risate,<br>Il team Wonderworld FunBiz</p>",
    "attachments": [],
    "isStarred": false,
    "labels": [
      "personal"
    ],
    "time": "Sat. Feb. 25 2023 09:51:00 GMT+0000 (GMT)",
    "replies": [],
    "folder": "inbox",
    "isRead": false
  },
  {
    "id": 182,
    "from": {
      "email": "winner@superlotto-global.com",
      "name": "SuperLotto Global",
      "avatar": require("@src/assets/images/portrait/superlotto.png").default
    },
    "to": [
      {
        "name": "Rafaela S",
        "email": "rafaela.s@pronto-posto.com"
      }
    ],
    "subject": "Hai vinto!",
    "cc": [],
    "bcc": [],
    "message": "<p>Congratulazioni, Rafaela!</p><p>Sei stata selezionata come vincitrice dell’estrazione SuperLotto. Per ritirare il premio, contatta il nostro servizio di assistenza e tieni a portata di mano i tuoi dati. Hai 48 ore per richiederlo.</p><br><p>Il team SuperLotto Global</p>",
    "attachments": [],
    "isStarred": false,
    "labels": [
      "personal"
    ],
    "time": "Wed. Mar. 01 2023 10:24:00 GMT+0000 (GMT)",
    "replies": [],
    "folder": "inbox",
    "isRead": false
  }
]}
